// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-application[data-v-f20fb66a]{flex-grow:1;margin:0 auto;max-width:1200px}.v-application.theme--light[data-v-f20fb66a]{color:var(--cp-black)}.v-main__wrap>div[data-v-f20fb66a]{height:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
